<template>

  <div>

    <search-model
      v-if="!model"
      @leave="$emit('leave')" />

    <info-model
      v-else
      :model="model"
      @leave="$emit('leave')"
      @next="$emit('changeScreen', {type: 'next', id: 0})"
      @badmodel="changeModel({ btag: model.btag })" />

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import SearchModel from './ScreenOne/SearchModel';
import InfoModel from './ScreenOne/InfoModel';

export default {
  components: {
    SearchModel,
    InfoModel,
  },
  computed: {
    ...mapState('buymodels', ['model']),
  },
  methods: {
    ...mapActions('buymodels', ['changeModel']),
    ...mapMutations('buymodels', ['RESET_MODEL']),
  }
}
</script>

<style lang="css">
</style>
